import { ETopic } from '../../types/topic';
export var TOPIC_ANSWERS = [{
  label: 'Модерация (проверка объявлений)',
  value: ETopic.Moderation
}, {
  label: 'Жалоба от собственника объекта',
  value: ETopic.ComplaintFromOwnerProperty
}, {
  label: 'Жалоба от собственника фотографий',
  value: ETopic.ComplaintFromOwnerPhoto
}, {
  label: 'Жалоба на объявление',
  value: ETopic.OfferComplaint
}, {
  label: 'Вход на сайт (авторизация, пароль, удаление аккаунта)',
  value: ETopic.Login
}, {
  label: 'Объявления (публикация, редактирование, удаление)',
  value: ETopic.Offers
}, {
  label: 'Зачисление или списание средств',
  value: ETopic.Money
}, {
  label: 'XML выгрузка/импорт объявлений из фида',
  value: ETopic.XmlUnloading
}, {
  label: 'Коммерческая недвижимость (все вопросы)',
  value: ETopic.Commercial
}, {
  label: 'Закрывающие документы / акты сверки',
  value: ETopic.Documents
}, {
  label: 'Коттеджные поселки (добавление, редактирование)',
  value: ETopic.VillageRequest
}, {
  label: 'Добавить или изменить проект строительной компании',
  value: ETopic.CountrysideBuildersProjectRequest
}, {
  label: 'Другой вопрос',
  value: ETopic.Another
}, {
  label: 'PR/СМИ',
  value: ETopic.PrMedia
}, {
  label: 'Размещение медийной рекламы (баннеров)',
  value: ETopic.Advertising
}];